<ion-content>
    <img class="bg-overlay" src="/assets/icon/ink_cloud.jpg" />
    <div class="login-wrap" [ngClass]="{'mobile-bg': platform === 'mobile', 'veeam': this.theme === 'veeam'}">

        <div class="big-logo">
            <div *ngIf="isPageReady" class="bg desktop-only">
                <img *ngIf="this.theme !== 'veeam'" src="assets/icon/welcome-journey-logo.svg">
                <img *ngIf="this.theme === 'veeam'" src="assets/theme/veeam/veeam-logo-2025-smaller.svg">
            </div>

            <img *ngIf="isPageReady && this.theme !== 'veeam'" class="logo-mobile mobile-only" src="assets/icon/journey-logo-mobile.svg">
            <img *ngIf="isPageReady && this.theme === 'veeam'" class="logo-mobile mobile-only" src="assets/theme/veeam/veeam-logo-2025.svg">
        </div>

        <div class="right-container">
            <div class="fit-box">
                <div class="height-shrinked">
                    <img *ngIf="isPageReady" [ngClass]="{'veeam': this.theme === 'veeam'}" class="alchemist desktop-only" src="assets/icon/alchemist-logo.svg">
                </div>
              <div class="message">
                <div>{{ "__LOGIN_VEEAM_EMPLOYEE_MESSAGE__" | translate }}</div>
                <div>{{ "__LOGIN_PLEASE_EMAIL__" | translate }} <a href="mailto:support@thisisalchemist.com">support@thisisalchemist.com</a></div>
              </div>
                <div [ngClass]="{'veeam': this.theme === 'veeam', 'disabled': this.loading}" class="login-button" (click)="doMicrosoftLogin('/login/sso')">
                    <img src="assets/img/windows-icon.svg">
                    <span>{{ "__LOGIN_SIGN_IN_WITH_MICROSOFT__" | translate }}</span>
                    <img class="desktop-only" src="assets/icon/arrow-right.svg">
                </div>
              <a class="can-not-sign-in-text" href="mailto:support@thisisalchemist.com">{{'__LOGIN_CANT_SIGN_IN__' | translate}}</a>
<!--                <div class="can-not-sign-in-text" (click)="forgotPassword()">{{'__LOGIN_CANT_SIGN_IN__' | translate}}</div>-->
            </div>
        </div>

        <div class="bottom-container">
            <img *ngIf="isPageReady" [ngClass]="{'veeam': this.theme === 'veeam'}" class="alchemist" src="assets/icon/alchemist-logo.svg">
        </div>
    </div>
</ion-content>
